var map = {
	"./plants/DGK_Amur.jpg": 6090,
	"./plants/DGK_Hab.jpg": 4316,
	"./plants/DGK_Nyr.jpg": 4678,
	"./plants/DGK_Prim.jpg": 1245,
	"./plants/PMES.jpg": 6617,
	"./plants/Smol.jpg": 3057,
	"./service/domodedovo.jpg": 549,
	"./service/kuban.jpg": 4814,
	"./service/kuban.webp": 7482,
	"./service/kurchatovskiy.jpg": 6014,
	"./service/reto.jpg": 8321,
	"./service/tula.jpg": 8125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;